// TODO: Temporary de-dupe until bug in WCS is resolved: https://jira.nap/browse/WCSCMS-21652
export const getCardTypes = (cardTypes) => {
    if (!cardTypes) return cardTypes;

    const set = new Set();
    cardTypes.forEach(({ code }) => {
        set.add(code);
    });

    return Array.from(set);
};
export default getCardTypes;
